import { tokens, useTheme } from "../../glassTheme.tsx";
import { GlassFloat } from "./Glass.tsx";

/** The floating pill's smaller sibling — a module's own tabs (§0 "segment control"). */
export function Segment<T extends string>({
  options, value, onChange,
}: { options: { key: T; label: string }[]; value: T; onChange: (v: T) => void }) {
  const { colors } = useTheme();
  return (
    <GlassFloat style={{ display: "inline-flex", gap: 2, padding: 4 }}>
      {options.map((o) => {
        const on = o.key === value;
        return (
          <button
            key={o.key}
            onClick={() => onChange(o.key)}
            style={{
              padding: "6px 12px", borderRadius: 999, border: "none", cursor: "pointer",
              fontFamily: tokens.font.sans, fontSize: tokens.type.segment.size,
              background: on ? colors.accentSoft : "transparent",
              color: on ? colors.ink : colors.ink2,
            }}
          >{o.label}</button>
        );
      })}
    </GlassFloat>
  );
}
